import React from 'react'
import { Icon, l } from '@manychat/manyui'

import { EditorAiTextImproverPopover } from './popovers/EditorAiTextImprover/EditorAiTextImproverPopover'
import EmojisPopover from './popovers/Emojis'
import SmartLinksPopover from './popovers/SmartLinks/SmartLinks'
import VariablesPopover from './popovers/Variables'
import { Tools, IToolPopover } from './toolbarInterfaces'

export const ToolsToggles: Record<
  string,
  { label?: string; icon?: React.ReactElement; component?: React.ReactElement; testId: string }
> = {
  [Tools.emoji]: { icon: <Icon.Smile size={20} />, testId: 'emoji-tool' },
  [Tools.vars]: { icon: <Icon.Data size={19} />, testId: 'vars-tool' },
  [Tools.smartLinks]: { icon: <Icon.Link size={24} />, testId: 'smartLinks-tool' },
  [Tools.aiContentGenerator]: {
    icon: (
      <>
        <Icon.Ai className="m-r-xxs" size={20} />

        <span style={{ transform: 'translateY(-1px)' }}>{l.translate('Improve')}</span>
      </>
    ),
    testId: 'aiContentGenerator-tool',
  },
}

export const ToolsPopovers: Record<Tools, IToolPopover> = {
  [Tools.emoji]: EmojisPopover,
  [Tools.vars]: VariablesPopover,
  [Tools.smartLinks]: SmartLinksPopover,
  [Tools.aiContentGenerator]: EditorAiTextImproverPopover,
}
